/* @ngInject */
function OrganizationFactory($http, Utils) {
  class Organization {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static get() {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/organization`)
        .then((response) => new Organization(response.data));
    }

    static getBySlug(slug) {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/organizations/slug/${slug}`)
        .then((response) => new Organization(response.data));
    }

    isRequestedCustomDomain() {
      return this.settings.customDomain && this.settings.customDomain.url && !this.settings.customDomain.enabled;
    }

    isVerifiedCustomDomain() {
      return this.settings.customDomain && this.settings.customDomain.url && this.settings.customDomain.verified;
    }

    isEnabledCustomDomain() {
      return this.settings.customDomain && this.settings.customDomain.url && this.settings.customDomain.enabled;
    }

    hasSignature() {
      return this.settings.signature && this.settings.signature.metadata && this.settings.signature.metadata.url;
    }

    getDomainUrl() {
      let domainUrl = process.env.PROPOSAL_URL;
      if (this.settings.customDomain && this.settings.customDomain.url && this.settings.customDomain.enabled) {
        const customDomainUrl = this.settings.customDomain.url;
        if (Utils.urlHasHttpProtocol(customDomainUrl)) domainUrl = customDomainUrl;
        else
          domainUrl = `${
            process.env.ENV === "prod" || process.env.ENV === "staging" ? "https://" : "http://"
          }${customDomainUrl}`;
      }
      return domainUrl;
    }

    uniqueSlug() {
      return $http.get(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/unique/slug/${this.slug}`);
    }

    suggestSlug() {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/suggest/slug`, {
          params: { name: this.name },
        })
        .then((response) => response.data);
    }

    getDefaultQuoteNumber() {
      return this.settings.quoteNumbers.find((quoteNumber) => quoteNumber.default);
    }

    create() {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/organization`, this)
        .then((response) => angular.extend(this, response.data));
    }

    update() {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/organization/${this.id}`, this)
        .then((response) => angular.extend(this, response.data));
    }

    updateMetadataLogo(metadata) {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/logo`, metadata)
        .then((response) => angular.extend(this, response.data));
    }

    updateCurrency(currency, updateTariffs) {
      return $http
        .put(
          `${process.env.SERVER_URL}/api/secure/organization/${this.id}`,
          { settings: { currency } },
          { params: { updateTariffs } },
        )
        .then((response) => angular.extend(this, response.data));
    }

    removeUser(userId) {
      return $http.delete(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/user/${userId}`);
    }

    editQuoteNumber(quoteNumberId, nextNumber, isDefault) {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/settings/quoteNumbers/${quoteNumberId}`, {
          nextNumber: nextNumber,
          default: isDefault,
        })
        .then((response) => angular.extend(this, response.data));
    }

    createTax(name, percentage) {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/settings/taxes`, {
          name,
          percentage,
        })
        .then((response) => angular.extend(this, response.data));
    }

    editTax(taxId, name, percentage, isDefault) {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/settings/taxes/${taxId}`, {
          name: name,
          percentage: percentage,
          default: isDefault,
        })
        .then((response) => angular.extend(this, response.data));
    }

    toggleAdmin(userId) {
      return $http
        .put(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/admin/toggle`, {
          userId: userId,
        })
        .then((response) => angular.extend(this, response.data));
    }

    deleteTax(taxId) {
      return $http
        .delete(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/settings/taxes/${taxId}`)
        .then((response) => angular.extend(this, response.data));
    }

    verifyCustomDomain() {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/organization/${this.id}/custom-domain/verify`)
        .then((response) => angular.extend(this, response.data));
    }

    isOwner(user) {
      const ownerId = angular.isString(this.owner) ? this.owner : this.owner.id;

      return ownerId === user.id;
    }

    isAdmin(user) {
      let isAdmin = false;
      if (this.admins && this.admins.length > 0)
        isAdmin = angular.isString(this.admins[0])
          ? this.admins.some((admin) => admin === user.id)
          : this.admins.some((admin) => admin.id === user.id);
      return isAdmin;
    }
  }

  return Organization;
}

export default OrganizationFactory;
